import React from 'react'

import FormattedMessage from 'components/FormattedMessage'
import Stepper from '.'

const RequestStepper: React.FC<RequestStepperProps> = ({ step }) => (
  <Stepper currentStep={step}>
    <FormattedMessage id="contactRequest.stepper.basic" />
    <FormattedMessage id="contactRequest.stepper.details" />
    <FormattedMessage id="contactRequest.stepper.overview" />
  </Stepper>
)

type RequestStepperProps = {step: number}

export default RequestStepper
